// extracted by mini-css-extract-plugin
export default {"container":"tags-box_container__2wfBC"};